export default {
  grade: {
    code: "Grade Code",
    name: "Grade Name",
    description: "Grade Description",
  }
};
